// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L9vz","badges":"styles_badges__1ZCRK"};